export default __webpack_public_path__ + "static/media/Soratha_Pilimaya.73662448.jpg";